import { useLayoutEffect, useRef } from "react";
import { cn } from "@/zapi-frontend/shared/lib/utils";

function SpinnerTrackCircle() {
  return <circle cx="8" cy="8" r="7" stroke="var(--innovera-zinc150)" strokeWidth="1.25" />;
}

// A CSS animation starts counting when its element mounts, so spinners that appear at
// different moments (one chapter starts generating after another) rotate out of phase.
// Re-anchoring them to the document timeline origin keeps every spinner on screen at the
// same angle, no matter when it appeared.
export function SyncedSpinner({ className }: { className?: string }) {
  const ref = useRef<SVGSVGElement>(null);

  useLayoutEffect(() => {
    for (const animation of ref.current?.getAnimations() ?? []) {
      animation.startTime = 0;
    }
  }, []);

  return (
    <svg
      ref={ref}
      aria-hidden
      viewBox="0 0 16 16"
      fill="none"
      className={cn("block size-4 shrink-0 origin-center animate-spin", className)}
    >
      <SpinnerTrackCircle />
      <path d="M8 1A7 7 0 0 1 15 8" stroke="var(--innovera-zinc900)" strokeWidth="1.25" strokeLinecap="round" />
    </svg>
  );
}

export function SpinnerTrack({ className }: { className?: string }) {
  return (
    <svg aria-hidden viewBox="0 0 16 16" fill="none" className={cn("block size-4 shrink-0", className)}>
      <SpinnerTrackCircle />
    </svg>
  );
}
